import { configure } from 'mobx';
import AppMod from 'widget/App/AppMod';
import AccoumulateMod from 'widget/Accoumulate/AccoumulateMod';
import ShopHomeMod from 'pages/Shop/Home/ShopHome/ShopHomeMod';

configure({
  enforceActions: 'never',
  isolateGlobalState: true
});

const Stores = {
  AppMod,
  AccoumulateMod,
  ShopHomeMod
};

export default Stores;



// WEBPACK FOOTER //
// ./src/config/Stores.js